export default __webpack_public_path__ + "static/supervalue-9842962a2e9664c4d5b5ac0112ab090c.png";